import { render } from "./Theme.vue?vue&type=template&id=f82c377e"
const script = {}
script.render = render

export default script